import React from "react";
import Title from "../home/Title";
import ProjectsCard from "./ProjectsCard";
import { projects, PROJECT_GRID_ROWS } from "../../data/projects";

const Projects = () => {
  return (
    <div className="w-full min-w-0">
      <Title title="Recent" subTitle="Projects" />
      {/* Below "lgl" (1024px): a horizontal swipe strip — one card's worth of
          height instead of eleven stacked cards. At "lgl" and up: unchanged,
          the original two-column grid, replayed from the same flat list via
          grid-auto-flow: column (see PROJECT_GRID_ROWS). */}
      <p className="lgl:hidden text-xs text-faintColor px-6 -mt-1 mb-2">
        Swipe to explore →
      </p>
      <div
        className="w-full min-w-0 flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3 scrollbar-thin scrollbar-thumb-scrollThumb lgl:grid lgl:grid-cols-2 lgl:gap-6 lgl:overflow-visible lgl:pb-0 lgl:px-6 xl:gap-8"
        style={{ gridTemplateRows: `repeat(${PROJECT_GRID_ROWS}, auto)`, gridAutoFlow: "column" }}
      >
        {projects.map(({ href, ...project }) => (
          <a
            key={project.title}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex shrink-0 w-72 sm:w-80 snap-start lgl:w-auto lgl:shrink"
          >
            <ProjectsCard {...project} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default Projects;
